import { getPosts, buildQueryString } from "./helper";
import ApiService from "src/services/ApiService";
import getPrType from "src/utils/prType";
import localStore from 'src/utils/local-storage';

const prTypeList = getPrType();
const buildKey = (tile) => {
  const { autoGetBy, pageviewDuration, tags, category, pr } = tile;

  if (autoGetBy === "realtime") {
    return "autoGetBy=realtime";
  }

  const params = {
    autoGetBy,
    ...(autoGetBy === "pageview" && { pageviewDuration }),
    ...(category && { category: category.url }),
    // pr_type: pr || "0",
  };

  if (tags && tags.length > 0) {
    const compareTag = (a, b) => {
      if (a.id < b.id) {
        return -1;
      }
      if (a.id > b.id) {
        return 1;
      }
      return 0;
    };
    tags.sort(compareTag);

    tags.forEach((tag, index) => {
      params[`tag-${index}`] = tag.slug;
    });
  }

  const key = buildQueryString(params);

  return key;
};

const buildExceptIdsForBlock = (tiles) => {
  const exceptIdsForBlock = {};

  tiles.forEach(tile => {
    if (tile.duplicatePermission) {
      const key = buildKey(tile);
      if (!exceptIdsForBlock.hasOwnProperty(key)) {
        exceptIdsForBlock[key] = [];
      }
    }
  });

  return exceptIdsForBlock;
};

const cleanTiles = (tiles, exceptIds) => {
  // clean expired post in manual tile
  // then turn it to auto tile

  return tiles.map((tile, tileIndex) => {
    if (tile.type === "manual") {
      if (tile.expiredAt) {
        const compareTime =
          new Date(tile.expiredAt).getTime() - new Date().getTime();

        if (compareTime < 0) {
          const newTile = {
            ...tile,
            type: "auto",
            post: null,
            expiredAt: null,
          };

          delete newTile.__v;
          delete newTile._id;

          return newTile;
        } else {
          exceptIds.push(tile.post.id);
        }
      } else {
        exceptIds.push(tile.post.id);
      }
    }

    delete tile.__v;
    delete tile._id;

    return tile;
  });
};

const getPrPosts = async (pr_type) => {
  const prType = prTypeList.find(el => (el.value !== "0" && el.value === pr_type.toString() && el.expiredTime));
  const expiredTime = prType.expiredTime;
  const prPosts = (
    await getPosts({
      type: "da-dang",
      _sort: "publishedAt:desc",
      _limit: prType.limit,
      pr_type: prType.value,
      hidden_ne: true,
      publishedAt_gt: new Date(
        new Date().setHours(new Date().getHours() - expiredTime)
      ).toISOString(),
      channel: 1
    })
  ).posts;

  return prPosts;
};

const getPostsByTile = async (tile, pr_type = "0") => {
  const { autoGetBy, pageviewDuration, tags, category, pr } = tile;

  if (autoGetBy === "realtime") {
    const realtimePosts = [];

    const topviewPosts = await ApiService.get("/top-view-posts");
    topviewPosts.posts.map((postComponent) => {
      if (postComponent.post) {
        realtimePosts.push(postComponent.post);
      }
    });

    return realtimePosts;
  }

  const excludeCategories = localStore.get('_excludeCategories');
  // console.log(excludeCategories);

  const params = {
    type: "da-dang",
    _sort: autoGetBy === "pageview" ? "pageviews:desc" : "publishedAt:desc",
    ...(autoGetBy === "pageview" && {
      publishedAt_gt: new Date(
        new Date().setDate(
          new Date().getDate() - parseInt(pageviewDuration, 10)
        )
      ).toISOString(),
    }),
    _limit: 52,
    // id_nin: exceptIds,
    pr_type,
    ...(tags &&
      tags.length && {
        tags_in: tags.map((tag) => tag.id),
      }),
    ...(category && {
      categories: category.url,
    }),
    ...(!tags && !category && excludeCategories && {
      categories_nin: excludeCategories.split(",")
    }),
    editor_type_in: ['normal','mini','special'],
    hidden_ne: true,
    channel: 1
  };

  const posts = (await getPosts(params)).posts;

  return posts;
};

const mapTileTypeManual = (data, tile, exceptIds, exceptIdsForBlock) => {
  // handle pr
  if (
    tile.pr &&
    tile.pr !== "0" &&
    data[`pr_type=${tile.pr}`] &&
    data[`pr_type=${tile.pr}`].length > 0
  ) {
    // const prPost = data[`pr_type=${tile.pr}`].find(
    //   (p) => !exceptIds.includes(p.id)
    // );
    const prPost = data[`pr_type=${tile.pr}`].shift();
    exceptIds.push(prPost.id);

    if (prPost.id === tile.post.id) {
      return tile;
    } else {
      const newTile = {
        ...tile,
        post: prPost,
        nextPost: tile.post,
      };

      return newTile;
    }
  }

  if (tile.nextPost) {
    // trả lại next post khi không có bài pr phù hợp
    const newTile = {
      ...tile,
      post: tile.nextPost,
      nextPost: null
    };

    return newTile;
  }



  return tile;
}

const mapTileTypeAuto = (data, tile, exceptIds, exceptIdsForBlock) => {
  // fill pr post
  if (
    tile.pr &&
    tile.pr !== "0" &&
    data[`pr_type=${tile.pr}`] &&
    data[`pr_type=${tile.pr}`].length
  ) {
    const prPost = data[`pr_type=${tile.pr}`].find(
      (p) => !exceptIds.includes(p.id)
    );
    if (prPost) {
      const newTile = {
        ...tile,
        post: prPost,
      };
      exceptIds.push(prPost.id);

      return newTile;
    }
  }

  const key = buildKey(tile);
  const posts = data[key];
  const except = tile.duplicatePermission ? exceptIdsForBlock[key] : exceptIds;
  const chosenPost = posts.find((p) => !except.includes(p.id));

  // fallback trường hợp ko có bài, data bị thiếu
  if (!chosenPost) {
    return tile;
  }

  const newTile = {
    ...tile,
    post: chosenPost,
  };

  except.push(chosenPost.id);

  return newTile;
};

const getUpdatedHome = (tiles, dataPosts) => {
  const exceptIds = [];

  const ts = cleanTiles(tiles, exceptIds);

  const exceptIdsForBlock = buildExceptIdsForBlock(tiles);

  const newTs = ts.map((tile) => {
    if (tile.type === "manual") {
      return mapTileTypeManual(dataPosts, tile, exceptIds, exceptIdsForBlock);
    }

    return mapTileTypeAuto(dataPosts, tile, exceptIds, exceptIdsForBlock);
  });

  return newTs;
};

export { getUpdatedHome, buildKey, getPostsByTile, getPrPosts };
